// Lista desplegable propia del DS (select-custom) para los formularios que la usan
// fuera de los simuladores. Lo emite `pack_select_custom` solo en las páginas con un
// `<select is="select-custom">`: el polyfill de customized built-ins no va en el pack
// global, que tiene otros built-ins que hoy Safari deja en nativo a propósito.
//
// Safari (WebKit) no soporta `is="..."`: el shim y el polyfill deben ir antes del
// define. Repetir el polyfill en una página que ya lo trae (simuladores, styleguide)
// es inocuo: detecta que los built-ins ya funcionan y no vuelve a parchear.
import 'custom_elements/webkit-builtin-writable-shim'
import '@ungap/custom-elements'
import SelectCustom from 'custom_elements/select-custom'

customElements.get('select-custom') || customElements.define('select-custom', SelectCustom, { extends: 'select' })
